import LZString from 'lz-string';
import type { CardPair } from './types';
import { PAIRS_PER_DECK } from './types';

export function encodeDeckToUrl(pairs: readonly CardPair[]): string {
  const json = JSON.stringify(pairs);
  const compressed = LZString.compressToEncodedURIComponent(json);
  const { origin, pathname } = window.location;
  return `${origin}${pathname}?data=${compressed}`;
}

// 從目前頁面 URL 的 ?data= 嘗試解析；不存在或解析失敗回傳 null
export function decodeDeckFromUrl(): CardPair[] | null {
  const params = new URLSearchParams(window.location.search);
  const data = params.get('data');
  if (!data) return null;
  try {
    const decompressed = LZString.decompressFromEncodedURIComponent(data);
    if (!decompressed) return null;
    const parsed = JSON.parse(decompressed) as unknown;
    if (!Array.isArray(parsed) || parsed.length !== PAIRS_PER_DECK) return null;
    return parsed.map((p: unknown) => {
      const obj = (p ?? {}) as { q?: unknown; a?: unknown };
      return {
        q: typeof obj.q === 'string' ? obj.q : '',
        a: typeof obj.a === 'string' ? obj.a : '',
      };
    });
  } catch {
    return null;
  }
}
